/* WLB · live product-image resolver.
   The store re-processes product media periodically, so any hard-coded CDN
   image URL eventually 404s. This resolves the CURRENT image at runtime from
   the product handle via /products/{handle}.js (always up to date), with the
   old URL only as a last-resort fallback. Results are cached per handle. */
(function () {
  'use strict';
  var cache = {};

  function fetchImage(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        return p.featured_image || (p.images && p.images[0]) || null;
      })
      .catch(function () { return null; });
    return cache[handle];
  }

  // Hide until we have a working image; reveal on successful load. Falls back to
  // the provided URL only if the live lookup yields nothing.
  function set(img, handle, fallback) {
    if (!img) return;
    img.style.visibility = 'hidden';
    function show(url) {
      if (!url) return;
      img.onload = function () { img.style.visibility = 'visible'; };
      img.onerror = function () {
        if (fallback && img.src.indexOf(fallback) === -1) { img.src = fallback; }
      };
      img.src = url;
    }
    fetchImage(handle).then(function (url) { show(url || fallback || null); });
  }

  function handleFromUrl(url) {
    if (!url) return '';
    return String(url).split('?')[0].replace(/\/$/, '').split('/').pop();
  }

  // Auto-resolve any server-rendered <img data-wlb-handle="..."> on the page.
  function auto(root) {
    var imgs = (root || document).querySelectorAll('img[data-wlb-handle]');
    Array.prototype.forEach.call(imgs, function (img) {
      set(img, img.getAttribute('data-wlb-handle'), img.getAttribute('src') || '');
    });
  }

  window.WLBImg = { set: set, auto: auto, fetchImage: fetchImage, handleFromUrl: handleFromUrl };

  if (document.readyState !== 'loading') auto();
  else document.addEventListener('DOMContentLoaded', function () { auto(); });
})();
